import { FormatTypeEnum } from "../../api/models/format-type-enum";
import { DocumentPart } from "../../api/models";

export const getDefaultCustomFormattingString = (formattingString: string) => {
  switch (formattingString) {
    case FormatTypeEnum.NUMBER:
      return "#,##0.00;-#,##0.00;0";
    case FormatTypeEnum.PERCENTAGE:
      return "#,##0.00 %;-#,##0.00 %;0 %";
    case FormatTypeEnum.DATE:
      return "d/m/yy";
  }
};

export const getDefaultBuiltInFormattingString = (formattingString: string) => {
  switch (formattingString) {
    case FormatTypeEnum.NUMBER:
      return "37"; //#,##0;-#,##0
    case FormatTypeEnum.PERCENTAGE:
      return "10"; //0.00%
    case FormatTypeEnum.DATE:
      return "14"; //m/d/yy
  }
};

export const canInherit = (documentPart: DocumentPart) => {
  return documentPart.root || !documentPart.multiLinked;
};
